<template>
  <b-card class="ecommerce-card h-100 shadow-lg p-0 mb-0" no-body>
    <b-link
      :to="{
        name: `show-${title.value}`,
        params: { id: item.id },
      }"
      class="h-100 position-relative d-flex flex-column justify-content-between"
    >
      <div class="item-img text-center">
        <div
          class="card-img-top d-flex justify-content-center"
          style="height: 250px"
        >
          <b-img
            fluid
            :alt="item.name"
            :src="item.banner || errorImage"
            style="max-height: 250px"
            @error="setAltImg"
          />
        </div>
      </div>

      <b-card-body class="pb-0">
        <div class="item-wrapper">
          <div class="item-rating"></div>
          <div>
            <h5 class="item-price">{{ item.title || item.name }}</h5>
          </div>
        </div>
        <hr class="my-2" />
        <h6 class="item-name mt-1">
          <!-- <p
                  class="text-body text-justify"
                  v-html="item.brief_description"
                ></p> -->
          <b-card-text class="item-company">
            تعداد دانشجو :
            <span class="ml-25"> {{ item.students_count }} </span>
          </b-card-text>
          <b-card-text class="item-company">
            مدرس :
            <b-link
              class="ml-25"
              v-for="(user, index) in item.teachers.users"
              :key="index"
            >
              {{ user.first_name + " " + user.last_name }}
            </b-link>
          </b-card-text>
        </h6>
        <hr class="mt-2" />
        <h6 class="item-name mt-1">
          <b-card-text class="item-company">
            شهریه‌ :
            <span class="ml-25">
              <span
                class="text-danger"
                v-if="
                  finalAmount(item) != 0 && finalAmount(item) != item.amount
                "
                style="text-decoration: line-through"
              >
                {{ numberWithCommas(item.amount) }}
              </span>
              <span class="text-success"
                >{{
                  finalAmount != 0
                    ? numberWithCommas(finalAmount(item)) + " تومان "
                    : "رایگان"
                }}
              </span>
            </span>
          </b-card-text>
        </h6>
      </b-card-body>
      <div v-if="Object.keys(item).length && !item.bought">
        <div
          class="justify-content-center flex-wrap text-info font-weight-bold font-weight-bold p-50"
          v-show="!item.bought && item.can_buy && availableAtTimer"
        >
          <div class="align-center mb-50">
            زمان باقی مانده تا شروع ثبت نام :
          </div>

          <timer
            class="flex-row"
            color="info"
            :time="item.available_at"
            v-model="availableAtTimer"
          />
        </div>
        <div
          class="justify-content-center flex-wrap text-info font-weight-bold text-danger p-50"
          v-show="
            !item.bought &&
            item.can_buy &&
            !availableAtTimer &&
            unavailableAtTimer
          "
        >
          <div class="align-center mb-50">
            زمان باقی مانده تا پایان مهلت ثبت نام :
          </div>
          <timer
            class="flex-row"
            color="danger"
            :time="item.unavailable_at"
            v-model="unavailableAtTimer"
          />
        </div>
      </div>
      <div class="w-100 mt-auto" v-else>
        <b-badge variant="light-success" class="w-100 font-weight-bolder p-75">
          <h6 class="text-success mb-0" v-if="title.value == 'semester'">
            شما دانشجوی این ترم هستید
          </h6>
          <h6 class="text-success mb-0" v-else>شما دانشجوی این دوره هستید</h6>
        </b-badge>
      </div>
      <div class="w-100 mt-auto" v-if="!item.bought && !item.can_buy">
        <b-badge variant="light-warning" class="w-100 font-weight-bolder p-75">
          <h6 class="text-warning mb-0">مهلت ثبت نام به پایان رسیده است</h6>
        </b-badge>
      </div>
    </b-link>

    <b-button
      variant="gradient-primary"
      class="btn-cart shadow-lg mt-auto"
      block
      @click="checkout(item)"
      v-if="Object.keys(item).length && !item.bought && item.can_buy"
    >
      <feather-icon icon="ShoppingCartIcon" class="mr-50" />
      <span>خرید</span>
    </b-button>
  </b-card>
</template>

<script>
import Timer from "@core/components/timer/Timer.vue";
import {
  BButton,
  BLink,
  BBadge,
  BCard,
  BCardBody,
  BCardText,
  BImg,
} from "bootstrap-vue";
export default {
  components: {
    Timer,
    BButton,
    BLink,
    BBadge,
    BCard,
    BCardBody,
    BCardText,
    BImg,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    title: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      availableAtTimer: true,
      unavailableAtTimer: true,
    };
  },
  methods: {
    finalAmount(item) {
      let finalAmount = 0;
      if (item.percentage) {
        finalAmount =
          Number(item.amount) -
          (Number(item.amount) * Number(item.rebate)) / 100;
      } else {
        finalAmount = Number(item.amount) - Number(item.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
  },
};
</script>

<style></style>
